import React from 'react';

const GerTablero2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*0.95
  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/2a721e96-6cda-4c5b-bc71-15736482fc15/page/t5vSD"></iframe>
    </div>
  )
}

export default GerTablero2